import { ErrorList } from './../../../shared-components/controls/error-prompt/error-list.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Profile } from '../profile.model';
import { ProfileService } from '../profile.service';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
    selector: 'edit-topic',
    templateUrl: './edit-topic-dialog.component.html',
    styleUrls: [
        './edit-topic-dialog.component.css'
    ]
})
export class EditTopicDialogComponent implements OnInit {

    // Properties
    information: Profile;
    errors: ErrorList[] = [];
    originalTitle: string;
    originalStatus: string;
    saved: boolean;
    V10 = false;
    @ViewChild('titleField', { read: ElementRef, static: true }) titleField: ElementRef;

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<EditTopicDialogComponent>,
        private profileService: ProfileService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private loginService: LoginService
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: initializes the data
        this.V10 = this.loginService.LoginSettings.V10;
        this.information = this.data.information;
        this.originalTitle = this.information.Title;
        this.originalStatus = this.information.Status;
    }

    save() {
        // PRE: the save button is clicked
        // POST: updates the profile on the server and closes the dialogBox
        this.validate();
        if (this.errors.length == 0) {
            this.profileService.updateProfile(this.information).subscribe(() => {
                this.saved = true;
                this.dialogBox.close();
            });
        }
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: sets the data to the original title and closes the dialog box
        this.information.Title = this.originalTitle;
        this.information.Status = this.originalStatus;
        this.saved = false;
        this.dialogBox.close();
    }

    setStatus() {
        // PRE: the active checkbox is clicked
        // POST: sets the status to reflect the active
        if (this.information.Status == 'A') {
            this.information.Status = 'I';
        } else {
            this.information.Status = 'A';
        }
    }

    // Methods
    validate() {
        // POST: sets the errors
        this.errors = [];
        if (!this.information.Title || this.information.Title == '') {
            this.errors.push({
                fieldName: 'Topic Name',
                fieldRef: this.titleField,
                errorMsg: 'Field is required.'
            });
        }
    }
}
